App.factory('subscriptionService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function SubscriptionService() {
        this.check = function() {
            return baseService.get(Config.API_URL + '/subscription').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
        
    }
    return new SubscriptionService();
}]);